import React from 'react';
// import React, { Suspense } from "react";
import { Routes, Route, Outlet } from "react-router-dom";

//Layouts
import NonAuthLayout from "../Layouts/NonAuthLayout";
import VerticalLayout from "../Layouts/index";

//routes
import { authProtectedRoutes, publicRoutes } from "./allRoutes";
import { AuthProtected } from './AuthProtected';
// import LoaderV1 from "../Components/Common/LoaderV1";

const Index = () => {
    return (
        <React.Fragment>
               {/* <Suspense fallback={<LoaderV1/>}> */}
            <Routes>
                {/* Public routes with NonAuthLayout */}
                {publicRoutes.map((route, idx) => (
                    <Route
                        path={route.path}
                        element={
                            <NonAuthLayout>
                                {route.component}
                            </NonAuthLayout>
                        }
                        key={idx}
                    />
                ))}

                {/* Protected routes with VerticalLayout - Layout renders once */}
                <Route
                    element={
                        <AuthProtected />
                    }
                >
                    <Route
                        element={<VerticalLayout />}
                    >
                        {authProtectedRoutes.map((route, idx) => (
                            <Route
                                path={route.path}
                                element={route.component}
                                key={idx}
                            />
                        ))}
                    </Route>
                </Route>
            </Routes>
            {/* </Suspense> */}
        </React.Fragment>
    );
};

export default Index;